import axios from 'axios';
import Common from './Common';
export default {
    // getAll() {
    //     return axios.get(Common.api + 'seller-login');
    // },
    getEstimation(id) {
        return axios.get(Common.api + 'get-my-req-list/' + id);
    },
    getSellerInfo(id) {
        return axios.get(Common.api + 'seller-dashboard/' + id);
    },
    createChangePassword(data) {
        return axios.post(Common.api + 'change-password', data);
    },
    getTradings(id) {
        return axios.get(Common.api + 'get-my-tradings-seller/' + id);
    },
    getCompletes(id) {
        return axios.get(Common.api + 'get-my-completed-seller/' + id);
    },
    // createResgistration1(data){
    //     return axios.post(Common.api + 'seller-reg-first', data);
    // },
    // createResgistration2(data){
    //     return axios.post(Common.api + 'seller-reg-second', data);
    // },
    // update(id,data){
    //     return axios.put(Common.api+'seller-login'+id,data);
    // }
}